import { toast } from "vue3-toastify";

function refreshMessage() {
  queryMessage();
  passwordMessage();
}

function passwordMessage() {
  let data = $root.user.getData();

  if (data?.con_passudt != undefined) {
    // Message d'allertr quand le mot de passe va expirer dans moins de 15 jours
    let date = new Date(data.con_passudt);
    let dateNow = new Date();
    let diff = date - dateNow;
    let days = Math.floor(diff / (1000 * 60 * 60 * 24));

    days = Math.abs(days);

    let toastconfig = {
      ...$root.toastConfig
    };
    toastconfig.autoClose = false;

    if (days - ENV.USER_DAYS_CHANGE_PASSWORD >= -15 && days - ENV.USER_DAYS_CHANGE_PASSWORD <= 10) {
      toast.info(
        `<div style="padding-left: 8px;"><h3><strong>` +
        $root.$e(`Votre mot de passe va expirer dans`)+  ` ` +
        (ENV.USER_DAYS_CHANGE_PASSWORD - days) +  ` ` +
        $root.$e(`jours`) +
        `.</strong ></h3 ><p>` +
        $root.$e(`Merci de le changer pour continuer à accéder à votre compte`)+
        `</p></div >`
        ,

        toastconfig
      )
    }
  }
}

function queryMessage() {
  let toastconfig = {
    ...$root.toastConfig
  };
  toastconfig.autoClose = false;

  switch (window.location.search) {
    case '?jwt':
      toast.info(
        `<div style="padding-left: 8px;">` +
        `<h3>` +
        `<strong>Votre session a expiré.</strong>` +
        `</h3>` +
        `<p>Merci de vous reconnecter pour accéder à votre compte</p>` +
        `</div>`,
        toastconfig
      )
      break;

    default:
      break;
  }
}

function actionMessage() {

}

export default refreshMessage
